(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__tptcMenuMarker) return;
  window.__tptcMenuMarker = true;
  const motionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  const normalize = value => value.normalize('NFKC').replace(/\s+/g, ' ').trim().toLocaleLowerCase();
  const text = element => {
    const copy = element.cloneNode(true);
    copy.querySelectorAll('.tptc-menu-marker, svg, .visually-hidden, .svg-wrapper, [aria-hidden="true"]').forEach(node => node.remove());
    return normalize(copy.textContent);
  };
  function makeMarker(config) {
    const marker = document.createElement('span');
    marker.className = 'tptc-menu-marker';
    marker.setAttribute('aria-hidden', 'true');
    marker.dataset.symbol = config.markerSymbol;
    marker.dataset.animate = config.markerAnimate;
    if (config.markerSymbol === 'image') {
      const image = document.createElement('img');
      image.src = config.markerImage;
      image.alt = '';
      image.width = Number(config.markerSize) || 14;
      image.height = Number(config.markerSize) || 14;
      image.decoding = 'async';
      marker.append(image);
    } else if (config.markerSymbol === 'tree') {
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('focusable', 'false');
      const path = document.createElementNS(svg.namespaceURI, 'path');
      path.setAttribute('d', 'M12 2 6 9h3l-5 6h5l-6 5h18l-6-5h5l-5-6h3L12 2M12 20v3');
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '1.5');
      path.setAttribute('stroke-linecap', 'round');
      path.setAttribute('stroke-linejoin', 'round');
      path.setAttribute('pathLength', '1');
      path.setAttribute('stroke-dasharray', '1');
      svg.append(path);
      marker.append(svg);
    } else {
      marker.textContent = config.markerSymbol === 'dot' ? '●' : '✦';
    }
    if (config.markerAnimate === 'true' && config.markerSymbol !== 'image' && !(motionQuery && motionQuery.matches)) {
      const duration = Math.max(0.5, Number(config.markerDuration) || 2) * 1000;
      const pause = Math.max(0, Number(config.markerPause) || 0) * 1000;
      const delay = Math.max(0, Number(config.markerDelay) || 0) * 1000;
      const active = duration / (duration + pause);
      const target = config.markerSymbol === 'tree' ? marker.querySelector('path') : marker;
      const frames = config.markerSymbol === 'tree' ? [
        {strokeDashoffset: '1', opacity: 0.2, offset: 0},
        {strokeDashoffset: '0', opacity: 1, offset: active * 0.7},
        {strokeDashoffset: '0', opacity: 1, offset: active},
        {strokeDashoffset: '0', opacity: 1, offset: 1}
      ] : [
        {opacity: 1, offset: 0},
        {opacity: 0.2, offset: active * 0.5},
        {opacity: 1, offset: active},
        {opacity: 1, offset: 1}
      ];
      if (target && target.animate) target.animate(frames.map(frame => ({...frame, easing: 'ease-in-out'})), {duration: duration + pause, delay, iterations: Infinity, fill: 'backwards'});
    }
    return marker;
  }
  function sync(root) {
    const config = root.dataset;
    const title = normalize(config.markerTitle || '');
    const enabled = config.markerEnabled === 'true' && title !== '' && (config.markerSymbol !== 'image' || !!config.markerImage);
    const signature = JSON.stringify([config.markerSymbol, config.markerAnimate, config.markerImage, config.markerSize, config.markerDuration, config.markerPause, config.markerDelay, !!(motionQuery && motionQuery.matches)]);
    const matches = new Set();
    if (!enabled) {
      root.querySelectorAll('.tptc-menu-marker').forEach(marker => {
        if (marker.closest('[data-tptc-menu-marker-root]') !== root) return;
        marker.getAnimations?.({subtree: true}).forEach(animation => animation.cancel());
        marker.remove();
      });
    }
    if (enabled) {
      root.querySelectorAll('a, summary, button').forEach(item => {
        if (item.closest('[data-tptc-menu-marker-root]') !== root) return;
        if (item.querySelector('a, summary, button')) return;
        if (text(item) !== title) return;
        const label = [...item.querySelectorAll('span')].reverse().find(span =>
          !span.closest('.tptc-menu-marker, .svg-wrapper, .visually-hidden') && text(span) === title
        ) || item;
        matches.add(label);
        label.classList.add('tptc-menu-marker-host');
        label.style.setProperty('--tptc-marker-color', config.markerColor);
        label.style.setProperty('--tptc-marker-size', `${Number(config.markerSize) || 14}px`);
        label.style.setProperty('--tptc-marker-gap', `${Number(config.markerGap) || 0}px`);
        let marker = [...label.children].find(child => child.classList.contains('tptc-menu-marker'));
        if (marker && marker.dataset.signature !== signature) { marker.remove(); marker = null; }
        if (!marker) {
          marker = makeMarker(config);
          marker.dataset.signature = signature;
          label.append(marker);
        }
      });
    }
    root.querySelectorAll('.tptc-menu-marker-host').forEach(host => {
      if (host.closest('[data-tptc-menu-marker-root]') !== root || matches.has(host)) return;
      [...host.children].filter(child => child.classList.contains('tptc-menu-marker')).forEach(marker => marker.remove());
      host.classList.remove('tptc-menu-marker-host');
      ['color', 'size', 'gap'].forEach(key => host.style.removeProperty(`--tptc-marker-${key}`));
    });
  }
  let queued = false;
  function refresh() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      document.querySelectorAll('[data-tptc-menu-marker-root]').forEach(sync);
    });
  }
  function start() {
    refresh();
    new MutationObserver(records => {
      const relevant = records.some(record => {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (target && target.closest('[data-tptc-menu-marker-root]')) return true;
        return [...record.addedNodes].some(node => node.nodeType === 1 &&
          (node.matches('[data-tptc-menu-marker-root]') || node.querySelector('[data-tptc-menu-marker-root]')));
      });
      if (relevant) refresh();
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: [
        'data-marker-enabled', 'data-marker-title', 'data-marker-symbol',
        'data-marker-image', 'data-marker-duration', 'data-marker-pause',
        'data-marker-delay', 'data-marker-animate', 'data-marker-color',
        'data-marker-size', 'data-marker-gap'
      ]
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:reorder', refresh);
  document.addEventListener('shopify:block:deselect', refresh);
  document.addEventListener('shopify:block:select', refresh);
  if (motionQuery && motionQuery.addEventListener) motionQuery.addEventListener('change', refresh);
})();
  } catch(e) { console.error(e); }
})();

})();
